function Footer() {
    return (
        <footer className="bg-slate-900 text-slate-400 py-10 text-center">
            <div className="container mx-auto px-6">
                <p className="text-lg font-semibold text-white mb-2">Adnin Rais</p>
                <p className="mb-4 text-sm">+62 857-15162024</p>
                <p className="text-xs">&copy; 2026 Adnin Rais. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
